<template>
  <section>
    <challenge-admin />
  </section>
</template>
<script>
import ChallengeAdmin from '@/Components/Challenges/challenges-listing'
export default {
  name: 'challenges',
  components: {
    ChallengeAdmin,
  },
}
</script>
<style scoped>
</style>
